import { BiitValueState, FirstValue } from "../actions/types";


const INITAL_STATE = {};
const STATE={firstValue:0, total:0}

export default (state = INITAL_STATE, action: { type: string, payload: BiitValueState }) => {
  switch (action.type) {
    case "PERFORM_SYNC":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const performSyncValue= (state = STATE, action: { type: string, payload: FirstValue }) => {
  switch (action.type) {
    case 'PERFORM_SYNC_VALUE':      
      return { ...state, firstValue:action.payload.firstValue };
    case 'PERFORM_SYNC_TOTAL_VALUE':
      return { ...state, total: action.payload };
    default:
      return state;
  }
}

